export default "__VITE_ASSET__CXG$$tiM__"